import trip1Background from "../../assets/images/carousel/carousel1.webp";
import trip2Background from "../../assets/images/carousel/carousel2.webp";
import trip3Background from "../../assets/images/carousel/carousel3.webp";
import trip5Background from "../../assets/images/carousel/carousel5.webp";

import { TripInformation } from "./TripInformation";

const presentationTrips: TripInformation[] = [
  {
    id: "pollensa-trip",
    tripObjectId: "25cd3b08-3cab-4dce-a05a-cc4279c53e75",
    url: "/pollensa-bay",
    title: "trips.pollensa-bay.title",
    description: "trips.pollensa-bay.description",
    priceAdult: "trips.pollensa-bay.adults",
    priceChild: "trips.pollensa-bay.children",
    priceChildrenUnderFive: "trips.pollensa-bay.childrens-under-5",
    duration: "trips.pollensa-bay.duration",
    backgroundImage: "carousel1",
    backgroundImageImg: trip1Background,
    color: "#6C3483",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.7068288826263!2d3.0823030752772036!3d39.90319568673602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1297d58759fd62e9%3A0xe7f7093d90c0bd06!2sLanchas%20La%20Gaviota!5e0!3m2!1sen!2suk!4v1742660936835!5m2!1sen!2suk",
    moreInformation: {
      what: "trips.pollensa-bay.what",
      price: "trips.pollensa-bay.price-include",
      practical: "trips.pollensa-bay.practical",
      timetable: "trips.pollensa-bay.timetable",
      departurePoint: "trips.pollensa-bay.departurePoint",
    },
  },
  {
    id: "formentor-beach-trip",
    tripObjectId: "d5ca7b32-28fe-41ce-9d6f-03cacee46eb9",
    url: "/formentor-beach",
    title: "trips.formentor-beach.title",
    description: "trips.formentor-beach.description",
    priceAdult: "trips.formentor-beach.adults",
    priceChild: "trips.formentor-beach.children",
    priceChildrenUnderFive: "trips.formentor-beach.childrens-under-5",
    duration: "trips.formentor-beach.duration",
    backgroundImage: "carousel2",
    backgroundImageImg: trip2Background,
    color: "#F5B041",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.7068288826263!2d3.0823030752772036!3d39.90319568673602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1297d58759fd62e9%3A0xe7f7093d90c0bd06!2sLanchas%20La%20Gaviota!5e0!3m2!1sen!2suk!4v1742660936835!5m2!1sen!2suk",
    moreInformation: {
      what: "trips.formentor-beach.what",
      price: "trips.formentor-beach.price-include",
      practical: "trips.formentor-beach.practical",
      timetable: "trips.formentor-beach.timetable",
      departurePoint: "trips.formentor-beach.departurePoint",
    },
  },
  {
    id: "sant-vicenc-trip",
    tripObjectId: "e52dc7ec-7008-4968-8020-d0e54992ca20",
    url: "/cala-sant-vicenc",
    title: "trips.cala-sant-vicens-colomer.title",
    description: "trips.cala-sant-vicens-colomer.description",
    priceAdult: "trips.cala-sant-vicens-colomer.adults",
    priceChild: "trips.cala-sant-vicens-colomer.children",
    priceChildrenUnderFive: "trips.cala-sant-vicens-colomer.childrens-under-5",
    duration: "trips.cala-sant-vicens-colomer.duration",
    backgroundImage: "carousel3",
    backgroundImageImg: trip3Background,
    color: "#7B241C",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.7068288826263!2d3.0823030752772036!3d39.90319568673602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1297d58759fd62e9%3A0xe7f7093d90c0bd06!2sLanchas%20La%20Gaviota!5e0!3m2!1sen!2suk!4v1742660936835!5m2!1sen!2suk",
    moreInformation: {
      what: "trips.cala-sant-vicens-colomer.what",
      price: "trips.cala-sant-vicens-colomer.price-include",
      practical: "trips.cala-sant-vicens-colomer.practical",
      timetable: "trips.cala-sant-vicens-colomer.timetable",
      departurePoint: "trips.cala-sant-vicens-colomer.departurePoint",
    },
  },
  {
    id: "formentor-point-trip",
    tripObjectId: "27bc2d11-5cd2-4b39-89ed-bce659189312",
    url: "/formentor-point",
    title: "trips.formentor-point.title",
    description: "trips.formentor-point.description",
    priceAdult: "trips.formentor-point.adults",
    priceChild: "trips.formentor-point.children",
    priceChildrenUnderFive: "trips.formentor-point.childrens-under-5",
    duration: "trips.formentor-point.duration",
    backgroundImage: "carousel1",
    backgroundImageImg: trip1Background,
    color: "#1ABC9C",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.7068288826263!2d3.0823030752772036!3d39.90319568673602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1297d58759fd62e9%3A0xe7f7093d90c0bd06!2sLanchas%20La%20Gaviota!5e0!3m2!1sen!2suk!4v1742660936835!5m2!1sen!2suk",
    moreInformation: {
      what: "trips.formentor-point.what",
      price: "trips.formentor-point.price-include",
      practical: "trips.formentor-point.practical",
      timetable: "trips.formentor-point.timetable",
      departurePoint: "trips.formentor-point.departurePoint",
    },
  },
  {
    id: "dolphins",
    tripObjectId: "3bf4cec8-fef2-4208-a8f4-97a69a48d029",
    url: "/dolphins",
    title: "trips.dolphins.title",
    description: "trips.dolphins.description",
    priceAdult: "trips.dolphins.adults",
    priceChild: "trips.dolphins.children",
    priceChildrenUnderFive: "trips.dolphins.childrens-under-5",
    duration: "trips.dolphins.duration",
    backgroundImage: "carousel5",
    backgroundImageImg: trip5Background,
    color: "#FF7F50",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.7068288826263!2d3.0823030752772036!3d39.90319568673602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1297d58759fd62e9%3A0xe7f7093d90c0bd06!2sLanchas%20La%20Gaviota!5e0!3m2!1sen!2suk!4v1742660936835!5m2!1sen!2suk",
    moreInformation: {
      what: "trips.dolphins.what",
      price: "trips.dolphins.price-include",
      practical: "trips.dolphins.practical",
      timetable: "trips.dolphins.timetable",
      departurePoint: "trips.dolphins.departurePoint",
    },
  },
];

const defaultPresentationTrip = {
  id: "pollensa-trip",
  tripObjectId: "00000000-0000-0000-0000-000000000000",
  url: "/pollensa-bay",
  title: "trips.pollensa-bay.title",
  description: "trips.pollensa-bay.description",
  priceAdult: "trips.pollensa-bay.adults",
  priceChild: "trips.pollensa-bay.children",
  priceChildrenUnderFive: "trips.pollensa-bay.childrens-under-5",
  duration: "trips.pollensa-bay.duration",
  backgroundImage: "carousel1",
  backgroundImageImg: trip1Background,
  color: "#6C3483",
  carouselItems: [],
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.7068288826263!2d3.0823030752772036!3d39.90319568673602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1297d58759fd62e9%3A0xe7f7093d90c0bd06!2sLanchas%20La%20Gaviota!5e0!3m2!1sen!2suk!4v1742660936835!5m2!1sen!2suk",
  moreInformation: {
    what: "trips.pollensa-bay.what",
    price: "trips.pollensa-bay.price-include",
    practical: "trips.pollensa-bay.practical",
    timetable: "trips.pollensa-bay.timetable",
    departurePoint: "trips.pollensa-bay.departurePoint",
  },
};

export { defaultPresentationTrip, presentationTrips };
